import { render } from "./ItemRecipeForm.vue?vue&type=template&id=caaa6716"
import script from "./ItemRecipeForm.vue?vue&type=script&lang=js"
export * from "./ItemRecipeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__